// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-marker-popup-header {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: left;
  color: var(--grey45);
  color: var(--grey45);
  word-spacing: 3px;
}

.map-marker-popup-title {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: var(--grey71);
  color: var(--grey71);
  padding-right: 7px;
}

.map-marker-popup-value {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: right;
  color: var(--grey45);
  color: var(--grey45);
}

.map-polygon-tooltip {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: left;
  color: var(--grey45) !important;
  color: var(--grey45) !important;
}

/*:has working in all browsers except firefox*/
.leaflet-right:has(span) {
  width: 100%;
}

#toggle-handle {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  left: 2px;
  top: calc(50% - 12px / 2);
  background: #ffffff;
  box-shadow:
    0px 0px 3px rgba(64, 69, 79, 0.07),
    0px 1px 1px rgba(64, 69, 79, 0.3);
  border-radius: 40px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

#toggle-handle.on {
  transform: translateX(100%);
}

#toggle-switch {
  position: relative;
  width: 28px;
  height: 16px;
  border-radius: 80px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.map-legend {
  font-family: 'Source Sans Pro', sans-serif;
}

/*#toggle-switch:hover {*/
/*  background-color: #6a7ebf;*/
/*}*/

/*#toggle-switch:active {*/
/*  background-color: #3c4d88;*/
/*}*/

/*
 * N-245 grouped sensors (CustomMap.paintMarkers + mapSensorGroupHelpers.js).
 * Values from the design CSS (.claude/tasks/n-245/css/components.css /
 * desktop.css): "grouped map indicators", "tooltip", "grouped map list",
 * "grouped map element", "mobile text link".
 */
.sensor-group-badge-icon {
  background: transparent;
  border: 0;
}

.sensor-group-badge {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  background: var(--color-grey-45);
  background: var(--color-grey-45);
  border: 2px solid var(--color-grey-91);
  border: 2px solid var(--color-grey-91);
  border-radius: 50px;
  box-shadow:
    0px 0px 3px rgba(64, 69, 79, 0.1),
    0px 1px 4px rgba(64, 69, 79, 0.3);
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: var(--color-grey-100);
  color: var(--color-grey-100);
  cursor: pointer;
}

.sensor-group-popup .leaflet-popup-content-wrapper {
  padding: 0;
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  border-radius: 10px;
  box-shadow:
    0px 30px 120px -20px rgba(32, 34, 39, 0.3),
    0px 15px 24px -5px rgba(62, 67, 77, 0.07);
  overflow: hidden;
}

.sensor-group-popup .leaflet-popup-content {
  width: 320px !important;
  margin: 0;
}

.sensor-group-popup .leaflet-popup-tip {
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  box-shadow: none;
}

.sensor-group-list {
  box-sizing: border-box;
  max-height: 360px;
  overflow-y: auto;
  padding: 4px 0 4px 8px;
  font-family: 'Source Sans Pro', sans-serif;
  scrollbar-width: thin;
  scrollbar-color: var(--color-grey-80) var(--color-grey-100);
  scrollbar-color: var(--color-grey-80) var(--color-grey-100);
}

.sensor-group-list::-webkit-scrollbar {
  width: 12px;
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  border-left: 1px solid var(--color-grey-96);
  border-left: 1px solid var(--color-grey-96);
}

.sensor-group-list::-webkit-scrollbar-thumb {
  background: var(--color-grey-80);
  background: var(--color-grey-80);
  border: 3px solid var(--color-grey-100);
  border: 3px solid var(--color-grey-100);
  border-radius: 30px;
}

.sensor-group-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 8px 4px 0;
  cursor: pointer;
}

.sensor-group-row + .sensor-group-row {
  border-top: 1px solid var(--color-grey-91);
  border-top: 1px solid var(--color-grey-91);
}

.sensor-group-row-icon {
  display: flex;
  justify-content: center;
  flex: none;
  width: 32px;
  padding-top: 14px;
}

.sensor-group-row-data {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.sensor-group-row-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  height: 32px;
}

.sensor-group-row-label {
  flex: none;
  width: 96px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: var(--color-grey-71);
  color: var(--color-grey-71);
}

.sensor-group-row-value {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 8px 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.sensor-group-popup a.sensor-group-link {
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 8px 4px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--color-data-data);
  color: var(--color-data-data);
  text-decoration: underline;
}

.sensor-group-popup a.sensor-group-link:hover {
  background: var(--color-grey-98);
  background: var(--color-grey-98);
  color: var(--color-data-data);
  color: var(--color-data-data);
}

.sensor-group-popup a.sensor-group-link:active {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
}
`, "",{"version":3,"sources":["webpack://./app/styles/markers.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB;;qCAEmC;EACnC,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB,+BAA+B;AAC/B,IAAI;;AAEJ,0BAA0B;AAC1B,+BAA+B;AAC/B,IAAI;;AAEJ;;;;;EAKE;AACF;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,gCAAgC;EAChC,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB;;qCAEmC;EACnC,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB;;6CAE2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;EACrB,2DAA2D;EAC3D,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,iCAAiC;EACjC,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,uCAAuC;EACvC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC","sourcesContent":[".map-marker-popup-header {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.88;\n  letter-spacing: normal;\n  text-align: left;\n  color: var(--grey45);\n  color: var(--grey45);\n  word-spacing: 3px;\n}\n\n.map-marker-popup-title {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.6;\n  letter-spacing: normal;\n  text-align: left;\n  color: var(--grey71);\n  color: var(--grey71);\n  padding-right: 7px;\n}\n\n.map-marker-popup-value {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.6;\n  letter-spacing: normal;\n  text-align: right;\n  color: var(--grey45);\n  color: var(--grey45);\n}\n\n.map-polygon-tooltip {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.88;\n  letter-spacing: normal;\n  text-align: left;\n  color: var(--grey45) !important;\n  color: var(--grey45) !important;\n}\n\n/*:has working in all browsers except firefox*/\n.leaflet-right:has(span) {\n  width: 100%;\n}\n\n#toggle-handle {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 12px;\n  height: 12px;\n  left: 2px;\n  top: calc(50% - 12px / 2);\n  background: #ffffff;\n  box-shadow:\n    0px 0px 3px rgba(64, 69, 79, 0.07),\n    0px 1px 1px rgba(64, 69, 79, 0.3);\n  border-radius: 40px;\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out;\n}\n\n#toggle-handle.on {\n  transform: translateX(100%);\n}\n\n#toggle-switch {\n  position: relative;\n  width: 28px;\n  height: 16px;\n  border-radius: 80px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.map-legend {\n  font-family: 'Source Sans Pro', sans-serif;\n}\n\n/*#toggle-switch:hover {*/\n/*  background-color: #6a7ebf;*/\n/*}*/\n\n/*#toggle-switch:active {*/\n/*  background-color: #3c4d88;*/\n/*}*/\n\n/*\n * N-245 grouped sensors (CustomMap.paintMarkers + mapSensorGroupHelpers.js).\n * Values from the design CSS (.claude/tasks/n-245/css/components.css /\n * desktop.css): \"grouped map indicators\", \"tooltip\", \"grouped map list\",\n * \"grouped map element\", \"mobile text link\".\n */\n.sensor-group-badge-icon {\n  background: transparent;\n  border: 0;\n}\n\n.sensor-group-badge {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 6px;\n  background: var(--color-grey-45);\n  background: var(--color-grey-45);\n  border: 2px solid var(--color-grey-91);\n  border: 2px solid var(--color-grey-91);\n  border-radius: 50px;\n  box-shadow:\n    0px 0px 3px rgba(64, 69, 79, 0.1),\n    0px 1px 4px rgba(64, 69, 79, 0.3);\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: -0.02em;\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n  cursor: pointer;\n}\n\n.sensor-group-popup .leaflet-popup-content-wrapper {\n  padding: 0;\n  background: var(--color-grey-100);\n  background: var(--color-grey-100);\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  border-radius: 10px;\n  box-shadow:\n    0px 30px 120px -20px rgba(32, 34, 39, 0.3),\n    0px 15px 24px -5px rgba(62, 67, 77, 0.07);\n  overflow: hidden;\n}\n\n.sensor-group-popup .leaflet-popup-content {\n  width: 320px !important;\n  margin: 0;\n}\n\n.sensor-group-popup .leaflet-popup-tip {\n  background: var(--color-grey-100);\n  background: var(--color-grey-100);\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  box-shadow: none;\n}\n\n.sensor-group-list {\n  box-sizing: border-box;\n  max-height: 360px;\n  overflow-y: auto;\n  padding: 4px 0 4px 8px;\n  font-family: 'Source Sans Pro', sans-serif;\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-grey-80) var(--color-grey-100);\n  scrollbar-color: var(--color-grey-80) var(--color-grey-100);\n}\n\n.sensor-group-list::-webkit-scrollbar {\n  width: 12px;\n  background: var(--color-grey-100);\n  background: var(--color-grey-100);\n  border-left: 1px solid var(--color-grey-96);\n  border-left: 1px solid var(--color-grey-96);\n}\n\n.sensor-group-list::-webkit-scrollbar-thumb {\n  background: var(--color-grey-80);\n  background: var(--color-grey-80);\n  border: 3px solid var(--color-grey-100);\n  border: 3px solid var(--color-grey-100);\n  border-radius: 30px;\n}\n\n.sensor-group-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 4px 8px 4px 0;\n  cursor: pointer;\n}\n\n.sensor-group-row + .sensor-group-row {\n  border-top: 1px solid var(--color-grey-91);\n  border-top: 1px solid var(--color-grey-91);\n}\n\n.sensor-group-row-icon {\n  display: flex;\n  justify-content: center;\n  flex: none;\n  width: 32px;\n  padding-top: 14px;\n}\n\n.sensor-group-row-data {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.sensor-group-row-line {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 2px;\n  height: 32px;\n}\n\n.sensor-group-row-label {\n  flex: none;\n  width: 96px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--color-grey-71);\n  color: var(--color-grey-71);\n}\n\n.sensor-group-row-value {\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 8px 4px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n.sensor-group-popup a.sensor-group-link {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  padding: 8px 4px;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--color-data-data);\n  color: var(--color-data-data);\n  text-decoration: underline;\n}\n\n.sensor-group-popup a.sensor-group-link:hover {\n  background: var(--color-grey-98);\n  background: var(--color-grey-98);\n  color: var(--color-data-data);\n  color: var(--color-data-data);\n}\n\n.sensor-group-popup a.sensor-group-link:active {\n  background: var(--color-grey-96);\n  background: var(--color-grey-96);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
